import { api } from "@/lib/api";

export const searchFileRequest = (row, fileIndex) => {
  if (!Number.isInteger(fileIndex) || fileIndex < 0 || fileIndex >= Number(row?.file_count)) return null;
  if (row?.source === "admission") {
    const fileId = row.file_ids?.[fileIndex];
    if (!row.application_id || !fileId) return null;
    return {
      url: `/applications/${encodeURIComponent(row.application_id)}/documents/${encodeURIComponent(fileId)}/preview`,
      config: { responseType: "blob" },
    };
  }
  if (row?.source !== "staff" && row?.source !== "institution") return null;
  const docId = String(row.id || "").split(":")[1];
  if (!docId) return null;
  return {
    url: `/documents/${encodeURIComponent(docId)}/download`,
    config: { params: { file_index: fileIndex }, responseType: "blob" },
  };
};

export async function openDocumentFile(request, fileName, preview = false) {
  // Reserve the tab during the click, before the asynchronous authenticated request.
  const tab = preview ? window.open("about:blank", "_blank") : null;
  if (tab) tab.opener = null;
  try {
    const response = await api.get(request.url, request.config);
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    if (tab && !tab.closed) {
      tab.location.replace(url);
    } else {
      // A blocked/closed preview can still be downloaded through the same action.
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
}
